import { Component, Injector, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, NavigationExtras } from '@angular/router';
import { BaseEntityComponent, BnLoadingService, EntityPagedRequestParameters, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { BnAlertsService } from "@bndes/bndes-ux4/bn-alerts";
import { BnConfirmDirective } from "@bndes/bndes-ux4/bn-confirm";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";
import { BnUsuarioService, Usuario } from "@bndes/bndes-ux4/bn-usuario";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, takeUntil } from 'rxjs/operators';
import { FileUtilsService } from 'src/app/shared/file-utils.service';
import { ROLE_AGENTE_ENVIO, ROLE_GESTOR_CONSULTA, ROLE_GESTOR_ENVIO } from 'src/app/constantes/permissao.constants';
import { CanComponentDeactivate } from 'src/app/core/can-deactivate-guard.service';
import { Cnae, Dominio, Municipio } from 'src/app/model/dominio-operacao.model';
import { CODIGO_ESTADO_ATV_S_VINC, Estado } from 'src/app/model/estado.model';
import {
    Amortizacao,
    DetalheOperacaoCreditoLivre, EnderecoSede, HistoricoOperacaoCreditoLivre, OperacaoCreditoLivre, OutrasGarantias
} from 'src/app/model/operacao-credito-livre.model';
import { DetalheOperacaoGarantida, LiberacaoOperacaoGarantida, OperacaoGarantida } from 'src/app/model/operacao-garantida.model';
import { OperacaoRepasseBndes } from 'src/app/model/operacao-repasse-bndes.model';
import { PermissaoService } from 'src/app/shared/permissao.service';
import { ModalidadeService } from 'src/app/shared/services/modalidade.service';
import { RemoverAlertasService } from 'src/app/shared/services/remover-alertas.service';
import { SolicitacaoCancelamentoGarantiaService } from 'src/app/shared/services/solicitacao-cancelamento-garantia.service';
import { OcorrenciaValidacaoVO } from '../../../../shared/ocorrencia-validacao.vo';
import { SolicitacaoHonraService } from '../../../honra/solicitacao-honra/solicitacao-honra.service';
import { AmortizacaoAntecipadaService } from '../amortizacao/amortizacao-antecipada.service';
import { ListaOperacoesService } from '../lista-operacoes.service';
import { OperacaoCreditoLivreService } from '../operacao-credito-livre.service';
import { OperacaoGarantidaService } from '../operacao-garantida.service';
import { OperacaorepasseBndesService } from '../operacao-repasse-bndes-service';
import { TermosContratacaoModalComponent } from '../termos-e-condicoes/termos-contratacao-modal.component';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import moment from "moment";
import { MODALIDADES_ACEITAS_ABA_OUTRAS_GARANTIAS } from 'src/app/model/modalidade_garantia.model';
import { TermosLiquidacaoModalComponent } from './termos-informe-liquidacao/termos-liquidacao-modal.component';
import { ModalidadeGarantiaService } from 'src/app/features/modalidade_garantia/modalidade-garantia.service';

@Component({
    selector: 'app-operacao-detalhe',
    templateUrl: './operacao-detalhe.component.html',
    styleUrls: ['./operacao-detalhe.component.scss'],
    standalone: false
})
export class OperacaoDetalheComponent
  extends BaseEntityComponent<OperacaoGarantida> implements OnInit, CanComponentDeactivate, OnDestroy {

  private cancelamentoPeloGestor = false;
  private podeEditar = false;
  private podeCancelar = false;
  private emInclusao = false;
  private apenasVisualizacao = false;

  usuarioSubscription: Subscription;
  usuario: Usuario;

  private dataSistema: Date;

  public ocorrencias: OcorrenciaValidacaoVO[] = [];

  public dadosDominio: Dominio;

  public operacoes: OperacaoGarantida[];
  private idOperacao: number;

  private podeVisualizarNota: boolean = false;
  private podeCadastrarNota: boolean = false;

  private historico: OperacaoGarantida[];

  private dataContratacaoInicial: Date;
  private dataContratacaoFinal: Date;

  public operacaoCarregada = false;

  private atributosPaginacaoComponenteListagem: EntityPagedRequestParameters;

  public refreshAbaAmortizacao: number = 0;

  public permissaoLinkN03: boolean = false;

  public podeExportar: boolean = false;

  private visualizandoHistorico: boolean = false;

  public modoAditivo: boolean = false;

  public modoRetificacao: boolean = false;

  private opcaoEnvio: string;

  public solicitacoesHonra: any[];

  public modalidadeGarantia: string;
  public alteracaoClienteFinalAditivo: boolean = false;

  public garantias: any;
  public indicadorMei: boolean;
  public naturezaClienteFinal: number;
  public modalidadeAceita: Boolean = false;
  public podeInformarLiquidacao: boolean = false;
  public activeTabId: string = 'tabOperacao';
  private podeAdicionarEcgTerceiro: boolean = false;

  @ViewChild(BnConfirmDirective, { static: false }) vc: BnConfirmDirective;
  @ViewChild('meuId', { static: false }) botoesPersonalizados: TemplateRef<any>;

  @ViewChild('formOperacao', { static: false }) formOperacao: NgForm;
  GESTOR_CONSULTA: boolean;
  private readonly destroy$ = new Subject();

  // @override
  protected getRotaEdicao() {
    return 'operacoes';
  }
  // @override
  protected getRotaLista() {
    return 'operacoes/pesquisa';
  }

  // @override
  constructor(
    protected injector: Injector,
    protected operacaoService: OperacaoGarantidaService,
    protected operacaoCreditoLivreService: OperacaoCreditoLivreService,
    protected operacaoRepasseService: OperacaorepasseBndesService,
    private listaOperacoesService: ListaOperacoesService,
    private modalService: BnModalMessageService,
    private usuarioService: BnUsuarioService,
    private permissaoService: PermissaoService,
    private _modalService: NgbModal,
    private alertsService: BnAlertsService,
    private loadingService: BnLoadingService,
    private removerAlertasService: RemoverAlertasService,
    private activatedRoute: ActivatedRoute,
    private amortizacaoAntecipadaService: AmortizacaoAntecipadaService,
    private cancelamentoService:SolicitacaoCancelamentoGarantiaService,
    private solicitacaoHonraService: SolicitacaoHonraService,
    private modalidadeService: ModalidadeGarantiaService,
    private fileUtils: FileUtilsService,
    private dominiosService: DominiosService,
    private operacaoRepasseBndesService: OperacaorepasseBndesService,

  ) {
    super(operacaoService);

    this.modoEdicao = false;
  }

  // @override
  ngOnInit() {

    this.obterData();
    this.operacaoCarregada = false;
    this.dadosDominio = this.activatedRoute.snapshot.data['dominios'];
    this.dadosDominio.municipios = this.dadosDominio.municipios.sort((a, b) => a.nome.localeCompare(b.nome));
    this.garantias = this.dadosDominio.tiposOutrasGarantias;
    setTimeout(() => this.recuperarModelo(), 0);
    this.permissaoService.getPermissoesUsuarioAutenticado().subscribe((resp: any) => {
      this.permissaoLinkN03 = resp && resp[ROLE_GESTOR_CONSULTA];
      this.podeExportar = resp && resp[ROLE_GESTOR_CONSULTA];
      this.podeVisualizarNota = resp && (resp[ROLE_GESTOR_ENVIO] || resp[ROLE_GESTOR_CONSULTA]);
      this.podeCadastrarNota = resp && resp[ROLE_GESTOR_ENVIO];
      this.podeEditar = resp && resp[ROLE_AGENTE_ENVIO];
      // this.PodeVisualizarOpeScr = resp && resp[ROLE_GESTOR_CONSULTA];
      this.cancelamentoPeloGestor = resp && resp[ROLE_GESTOR_ENVIO];
      this.GESTOR_CONSULTA = resp && (resp[ROLE_GESTOR_CONSULTA] || resp[ROLE_GESTOR_ENVIO]);
      this.podeCancelar = this.podeEditar || this.cancelamentoPeloGestor;
    });

    this.modalidadeService.buscarModalidade().subscribe((modalidade: any) => {
      this.modalidadeGarantia = modalidade.sigla;
      this.podeAdicionarEcgTerceiro = modalidade.utilizaPagamentoDeEcgPorTerceiros;
    });

  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  public obterData() {
    this.dominiosService.getTimeStampISO()
      .pipe(takeUntil(this.destroy$))
      .subscribe((dataAtual: any) => {
        this.dataSistema = moment(dataAtual.nowDateISO, 'YYYYMMDD').toDate();
      })
  }

  private instanciaPropriedadesObjetoSeNulas(operacao: OperacaoCreditoLivre) {
    if (!operacao.enderecoSedeClienteFinal) {
      operacao.enderecoSedeClienteFinal = new EnderecoSede();
    }
    if (!operacao.detalhe) {
      operacao.detalhe = new DetalheOperacaoGarantida();
    }
    if (!operacao.detalhe.estado) {
      operacao.detalhe.estado = new Estado();
    }
    if (!operacao.detalheCreditoLivre) {
      operacao.detalheCreditoLivre = new DetalheOperacaoCreditoLivre();
    }
  }

  private historicoToOperacaoCreditoLivre(historico: HistoricoOperacaoCreditoLivre): OperacaoCreditoLivre {
    const operacao: OperacaoCreditoLivre = new OperacaoCreditoLivre();

    this.instanciaPropriedadesObjetoSeNulas(operacao);

    operacao.historico = true;
    operacao.codigoTipoOperacao = 'L';
    operacao.id = this.model.id;
    operacao.idOperacaoAgente = this.getModelAsOperacaoCreditoLivre(this.model).idOperacaoAgente;
    operacao.dataEnvio = historico.dataAlteracao;
    operacao.dataContratacao = this.ajustaCampoDate(historico.dataContratacao);
    operacao.valorOperacao = historico.valorOperacao;
    operacao.percentualGarantido = historico.percentualGarantido;
    operacao.riscoOperacao = historico.riscoOperacao;
    operacao.valorPerdaEsperada = historico.valorPerdaEsperada;
    operacao.ecgDeveSerSomadoAoValorOperacao = historico.ecgDeveSerSomadoAoValorOperacao;
    operacao.cnpjClienteFinal = historico.cnpjClienteFinal;
    operacao.razaoSocialClienteFinal = historico.razaoSocialClienteFinal;
    operacao.cnaePortariaGrandeEmpresa = historico.cnaePortariaGrandeEmpresa;
    operacao.modalidade = historico.modalidade;
    operacao.percentualIndexador = historico.percentualIndexador;
    operacao.dataNascSocioBeneficiario = historico.dataNascSocioBeneficiario;
    operacao.generoSocioBeneficiario = historico.generoSocioBeneficiario;

    operacao.detalhe.prazoCarenciaEmMeses = this.model.detalhe.prazoCarenciaEmMeses;
    operacao.detalhe.prazoAmortizacaoEmMeses = this.model.detalhe.prazoAmortizacaoEmMeses;
    operacao.detalhe.prazoEmMeses = this.model.detalhe.prazoAmortizacaoEmMeses;

    operacao.detalhe.prazoCarenciaContratualEmMeses = this.model.detalhe.prazoCarenciaContratualEmMeses;
    operacao.detalhe.prazoAmortizacaoContratualEmMeses = this.model.detalhe.prazoAmortizacaoContratualEmMeses;
    operacao.detalhe.prazoContratualEmMeses = this.model.detalhe.prazoContratualEmMeses;
    operacao.detalhe.percentualGarantidoASerHonrado = this.model.detalhe.percentualGarantidoASerHonrado

    operacao.detalhe.estado.motivoEstado = historico.motivoEstado;
    operacao.detalhe.estado.nomeEstado = historico.nomeEstado;
    operacao.detalhe.nomeCnaeClienteFinal = historico.nomeCnaeClienteFinal;

    operacao.detalhe.valorCredito = historico.valorCredito;
    operacao.detalhe.valorGarantido = historico.valorGarantido;
    operacao.detalhe.fatorK = historico.fatorK;
    operacao.detalhe.valorEcg = historico.valorEcg;

    operacao.detalheCreditoLivre.nomeCnaePortariaGrandeEmpresa = historico.nomeCnaePortariaGrandeEmpresa;
    operacao.detalheCreditoLivre.nomeIndexadorTaxaJuros = historico.nomeIndexadorTaxaJuros;
    operacao.detalheCreditoLivre.nomeMunicipioInvestimento = historico.nomeMunicipioInvestimento;
    operacao.detalheCreditoLivre.nomeNaturezaClienteFinal = historico.nomeNaturezaClienteFinal;

    if (historico.enderecoSedeClienteFinal) {
      operacao.enderecoSedeClienteFinal.nomeMunicipio = historico.enderecoSedeClienteFinal.nomeMunicipio;
      operacao.enderecoSedeClienteFinal.nomeTipoLogradouro = historico.enderecoSedeClienteFinal.nomeTipoLogradouro;
      operacao.enderecoSedeClienteFinal.nomeLogradouro = historico.enderecoSedeClienteFinal.nomeLogradouro;
      operacao.enderecoSedeClienteFinal.numeroLogradouro = historico.enderecoSedeClienteFinal.numeroLogradouro;
      operacao.enderecoSedeClienteFinal.complemento = historico.enderecoSedeClienteFinal.complemento;
      operacao.enderecoSedeClienteFinal.nomeBairro = historico.enderecoSedeClienteFinal.nomeBairro;
      operacao.enderecoSedeClienteFinal.cep = historico.enderecoSedeClienteFinal.cep;
    }

    operacao.outrasGarantias = historico.outrasGarantias;
    let indice = 0;
    historico.liberacoes.map(l => { l.numero = ++indice; l.retificada = null; });
    operacao.detalhe.liberacoes = historico.liberacoes;
    operacao.amortizacoes = historico.amortizacoes;
    operacao.taxaEfetivaAnual = historico.taxaEfetivaAnual;

    const totalLib = operacao.totalizaLiberacoes();
    operacao.atribuiSaldoPosAmortizacao();

    return operacao;
  }

  private atribuiModel(model) {
    this.model = model;
    this.instanciaPropriedadesObjetoSeNulas(model);
    this.operacoes = [this.model];
    this.model.dataContratacao = this.ajustaCampoDate(this.model.dataContratacao);
    this.model.dataReferenciaReceitaBruta = this.ajustaCampoDate(this.model.dataReferenciaReceitaBruta);
    this.model.dataNascSocioBeneficiario = this.ajustaCampoDate(this.model.dataNascSocioBeneficiario);
    this.liquidacaoPodeSerInformada();

    if (this.model.codigoTipoOperacao === 'L') {
      if (!(this.model instanceof OperacaoCreditoLivre)) {
        this.model = OperacaoCreditoLivre.fromDto(this.model);
      }
      const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;

      if (operacaoCreditoLivre.amortizacoes) {
        for (let i in operacaoCreditoLivre.amortizacoes) {
          operacaoCreditoLivre.amortizacoes[i].data = this.ajustaCampoDate(operacaoCreditoLivre.amortizacoes[i].data);
        }
      }

      if (operacaoCreditoLivre.detalhe.liberacoes) {
        for (let i in operacaoCreditoLivre.detalhe.liberacoes) {
          operacaoCreditoLivre.detalhe.liberacoes[i].data = this.ajustaCampoDate(operacaoCreditoLivre.detalhe.liberacoes[i].data);
        }
        operacaoCreditoLivre.atribuiSaldoPosAmortizacao();
      }

      if (operacaoCreditoLivre.detalhe.aditivos) {
        for (let i in operacaoCreditoLivre.detalhe.aditivos) {
          operacaoCreditoLivre.detalhe.aditivos[i].dataCelebracaoAditivo = this.ajustaCampoDate(operacaoCreditoLivre.detalhe.aditivos[i].dataCelebracaoAditivo);
          operacaoCreditoLivre.detalhe.aditivos[i].dataProtocoloAditivo = this.ajustaCampoDate(operacaoCreditoLivre.detalhe.aditivos[i].dataProtocoloAditivo);
        }
      }

      if (this.visualizandoHistorico) {
        if (operacaoCreditoLivre.detalheCreditoLivre.historicos) {
          for (const historico of operacaoCreditoLivre.detalheCreditoLivre.historicos) {
            const histOperacaoCreditoLivre: OperacaoCreditoLivre = this.historicoToOperacaoCreditoLivre(historico);
            this.operacoes.push(histOperacaoCreditoLivre);
          }
        }
      }
    } else {
      this.modalidadeAceita = [
        MODALIDADES_ACEITAS_ABA_OUTRAS_GARANTIAS.FGT,
        MODALIDADES_ACEITAS_ABA_OUTRAS_GARANTIAS.FGBS
      ].includes(this.model.modalidadeFGI);
    }
  }

  ajustaCampoDate(data: any) {
    if (typeof data === 'string') {
      if (data.length == 10) {
        data += ' 00:00:00';
      }
      return new Date(data);
    }

    return data;
  }

  grandeEmpresa(): boolean {
    return (this.model?.receitaBrutaClienteFinal && this.model?.receitaBrutaClienteFinal > 300000000.00);
  }

  visualizarHistorico(visualizar) {
    this.visualizandoHistorico = visualizar;
    this.atribuiModel(this.model);
  }


  tabChange(event) {
    if (event.nextId == "tabSolicitacoesHonra") {
      this.solicitacaoHonraService.getSolicitacoesHonraOperacao(this.model.id)
        .pipe(takeUntil(this.destroy$))
        .subscribe(resp => {
          this.solicitacoesHonra = resp && resp.resultados ? resp.resultados : [];
        });
    }
    else if (event.activeId == "tabSolicitacoesHonra") {
      this.solicitacoesHonra = undefined;
    }
  }

  adicionarLiberacao() {
    const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
    operacaoCreditoLivre.detalhe.liberacoes.push(new LiberacaoOperacaoGarantida());
  }

  removerLiberacao(i) {
    const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
    operacaoCreditoLivre.detalhe.liberacoes.splice(i, 1);
  }

  // @override
  editar(): void {
    super.editar();
  }

  // @override
  recuperarModelo() {
    // sobrescrevendo porque no angular-utils esta dando create quando e inclusao
    // padrao cria e depois edita
    // estamos editando e criando no final
    this.route.params
      .pipe(takeUntil(this.destroy$))
      .subscribe(params => {
      this.idOperacao = params['id'];

      if (this.idOperacao) {
        this.modoEdicao = false;
        this.emInclusao = false;
        this.buscarOperacaoInicial();

      } else {
        this.atribuiModel(new OperacaoCreditoLivre());

        const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
        operacaoCreditoLivre.dataReferenciaProtocolo = new Date();
        operacaoCreditoLivre.enderecoSedeClienteFinal = new EnderecoSede();
        operacaoCreditoLivre.detalhe = new DetalheOperacaoGarantida();
        operacaoCreditoLivre.detalhe.liberacoes = [new LiberacaoOperacaoGarantida()];
        operacaoCreditoLivre.amortizacoes = [];
        operacaoCreditoLivre.outrasGarantias = [];
        operacaoCreditoLivre.ecgDeveSerSomadoAoValorOperacao = "N";
        this.usuarioService.usuario$.pipe(takeUntil(this.destroy$)).subscribe(usuario => {
          operacaoCreditoLivre.cnpjAgenteFinanceiro = usuario && usuario.cnpj;
        });
        operacaoCreditoLivre.codigoTipoOperacao = 'L';
        operacaoCreditoLivre.percentualGarantido = 80;

        this.modoEdicao = true;
        this.emInclusao = true;
        this.operacaoCarregada = true;
        this.opcaoEnvio = undefined;
      }
    });
  }

  buscarOperacaoInicial(): void {
    this.operacaoService.findById(this.idOperacao)
      .pipe(takeUntil(this.destroy$))
      .subscribe(operacao => {
        this.atribuiModel(operacao);
        this.operacaoCarregada = true;
      });
  }

  voltar() {
    this.router.navigate(['/operacoes/pesquisa']);
  }

  cancela(): void {
    this.emInclusao = false;
    this.modoEdicao = false;
    this.removerAlertasService.removerTodos();
    this.cancelarEdicao();
  }

  removerAmortizacao(i) {
    const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
    for (let j = i; j<operacaoCreditoLivre.amortizacoes.length-1; j++) {
      operacaoCreditoLivre.amortizacoes[j].data = operacaoCreditoLivre.amortizacoes[j+1].data;
      operacaoCreditoLivre.amortizacoes[j].valor = operacaoCreditoLivre.amortizacoes[j+1].valor;
    }
    operacaoCreditoLivre.amortizacoes.pop();
    this.refreshAbaAmortizacao++;
  }

  adicionarAmortizacao() {
    const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
    operacaoCreditoLivre.amortizacoes.push(new Amortizacao());
    this.refreshAbaAmortizacao++;
  }

  cancelarAmortizacaoAntecipada(idAmortizacao: number): void {
    this.loadingService.bloqueiaTela();

    this.amortizacaoAntecipadaService.cancelarAmortizacao(this.idOperacao, idAmortizacao).pipe(takeUntil(this.destroy$)).subscribe(() => {
      this.recuperarModelo();
      this.loadingService.liberaTela();
    }, (err) => {
      console.error(err);
      this.loadingService.liberaTela();
    });
  }

  verificaLiberacoesOrdenadas(liberacoes: LiberacaoOperacaoGarantida[]) {
    let liberacaoAnterior;

    for (const liberacao of liberacoes) {
      if (liberacaoAnterior !== undefined && liberacaoAnterior.data > liberacao.data) {
        return false;
      }
      liberacaoAnterior = liberacao;
    }
    return true;
  }

  salvar() {
    this.refreshAbaAmortizacao++; // garante que uma última parcela eventualmente incluída seja vista na ordem cronológica após a reordenação
    super.antesDeSalvar();

    if (!this.modoRetificacao && !this.modoAditivo && this.opcaoEnvio === undefined) {
      this.alertsService.alertaErro("Erro", "É necessário escolher uma opção de envio: 'Consultar enquadramento' ou 'Contratar'.");
      return;
    }

    const apenasValidar = (this.opcaoEnvio === 'validar');
    const operacaoCreditoLivre: OperacaoCreditoLivre = <OperacaoCreditoLivre>this.model;
    if (operacaoCreditoLivre.detalhe && operacaoCreditoLivre.detalhe.liberacoes && operacaoCreditoLivre.detalhe.liberacoes.length && operacaoCreditoLivre.detalhe.liberacoes[0]) {
      operacaoCreditoLivre.dataPrimeiraLiberacao = operacaoCreditoLivre.detalhe.liberacoes[0].data;
      operacaoCreditoLivre.valorPrimeiraLiberacao = operacaoCreditoLivre.detalhe.liberacoes[0].valor;
    }

    if (operacaoCreditoLivre.percentualIndexador === undefined
      && operacaoCreditoLivre.indexadorTaxaJuros === '0') {
      operacaoCreditoLivre.percentualIndexador = 0;
    }

    if(!operacaoCreditoLivre.receitaBrutaClienteFinal || operacaoCreditoLivre.receitaBrutaClienteFinal === undefined) {
      this.alertsService.alertaErro("Erro", "O valor da Receita Bruta não pode ser nulo (vazio).");
      return;
    }

    operacaoCreditoLivre.ordenaAmortizacoesCronologicamente();

    if(this.modalidadeGarantia == "FGE"){
      if(!this.validaCodigoValidacaoUUID(operacaoCreditoLivre)){
          return;
        }
    }

    this.model.modalidadeFGI = this.modalidadeGarantia;

    if (this.modalidadeGarantia === 'FGT') {
      if(!this.verificarOperacaoAtendeRegrasTipoOutrasGarantias(operacaoCreditoLivre)) {
        return;
      }
    }

    let servico = "save";
    if (this.idOperacao) {
      if (this.modoAditivo) {
        servico = "aditar";
      }
      else if (this.modoRetificacao) {
        servico = "retificar";
      }
    }
    let clone: any = { ...this.model };
    if (this.modoAditivo) {
      // o serviço de aditivos não aceita informações de liberações,
      // já que não permite que liberações sejam aditadas
      clone.detalhe.liberacoes = undefined;
    }
    if (this.modoRetificacao || this.modoAditivo) {
      clone.detalhe.estado = undefined;
      clone.detalhe.historicos = undefined;
      if (clone.detalhe.liberacoes && clone.detalhe.liberacoes.length) {
        for (let liberacao of clone.detalhe.liberacoes) {
          liberacao.estadoDTO = undefined;
        }
        if (!this.verificaLiberacoesOrdenadas(clone.detalhe.liberacoes)) {
          this.alertsService.alertaErro("Erro", "As liberações não estão em ordem crescente de data");
          return;
        }
      }
    }
    this.ocorrencias = [];
    this.removerAlertasService.removerTodos();

    const modalRef = this._modalService.open(TermosContratacaoModalComponent, {
      windowClass: 'modal-dialog-md',
      backdrop: 'static'
    });

    modalRef.componentInstance.callback = (respModal) => {
      this.operacaoCreditoLivreService[servico](clone, apenasValidar).pipe(takeUntil(this.destroy$)).subscribe(respServico => {
        if (this.opcaoEnvio === 'validar') {
          this.exibeMensagemSucesso(respServico);
        } else {
          this.atribuiModel(respServico);
          this.aposSalvar(respServico);
        }
        this.ocorrencias = respServico.ocorrencias;
      }, error => {
        console.log(error);
        this.ocorrencias = this.operacaoCreditoLivreService.ocorrencias;
      });
    };
  }

  procuraCnae = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 2 ? []
        : this.dadosDominio.cnaes.filter(v => v.nome.toLowerCase().indexOf(term.toLowerCase()) > -1
          || v.codigo.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    );

  formataCnae = (result: Cnae) => result.codigo + " - " + result.nome;

  procuraMunicipio = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 2 ? []
        : this.dadosDominio.municipios.filter(v => v.nome.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    );

  formataMunicipio = (result: Municipio) => result.nome;

  podeLiberar(): boolean {
    return this.model && this.model.detalhe && this.model.detalhe.estado &&
      ["1", "3", "5", "7"].indexOf(<any>this.model.detalhe.estado.id) !== -1;
  }

  podeRetificar(): boolean {
    if (this.isRetificacaoHabilitada()) {
      return true;
    }
    return this.model && this.model.detalhe && this.dataFimRetificacoesValida() && this.model.detalhe.estado &&
      ["1", "3", "5", "6", "7", "8", "10", "11"].indexOf(<any>this.model.detalhe.estado.id) !== -1;
  }

  //INC000004033204
  isRetificacaoHabilitada(): boolean
  {
    var idOperacaoAtual : number;
    var idOperacaoFlexbilizada : number;

    const OPERACOES_FLEXIBILIZADAS: number[] = [184097, 173863, 96087, 184589, 333311, 177088, 91177, 283669, 285176];

    if (this.model != null && this.model.id != null)
    {
      let idOperacaoAtual = this.model.id;
      for(var i=0;i<OPERACOES_FLEXIBILIZADAS.length;i++)
      {
          let idOperacaoFlexbilizada = OPERACOES_FLEXIBILIZADAS[i];
          if (idOperacaoFlexbilizada == idOperacaoAtual) {
            return true;
          }

      }
    }
    return false;
  }

  dataFimRetificacoesValida(): boolean {
    if (!this.model.detalhe.dataFimRetificacoesTranche) {
      return true;
    }

    const dataFimRetificacoesTranche = this.toDate(this.model.detalhe.dataFimRetificacoesTranche, 'YYYY-MM-DD');

    return dataFimRetificacoesTranche >= this.dataSistema;
  }

  toDate(data, formato) {
    return moment(data, formato).toDate();
  }

  podeAmortizar(): boolean {
    return this.model && this.model.detalhe && this.model.detalhe.estado &&
      ["5", "6", "7", "11", "14"].indexOf(<any>this.model.detalhe.estado.id) !== -1;
  }

  podeAditar(): boolean {
    return this.model && this.model.detalhe && this.model.detalhe.indicadorAditivoHabilitadoTranche == "true" && this.model.detalhe.honraImpedeAditivo != "S" && this.model.detalhe.estado &&
      ["5", "6", "11"].indexOf(<any>this.model.detalhe.estado.id) != -1;
  }

  podeCancelarSolicitacaoOutorga(): boolean {
    return this.model && this.model.codigoTipoOperacao == 'L' && this.model.detalhe && this.model.detalhe.estado &&
      (["1", "3", "4"].indexOf(<any>this.model.detalhe.estado.id) >= 0
        || (this.model.detalhe.estado.id == 7 && this.model.detalhe.garantiaAtiva != "true"));
  }

  podeCancelarGarantia(): boolean {
    return this.model && this.model.detalhe && this.model.detalhe.estado &&
      (["5", "6", "11"].indexOf(<any>this.model.detalhe.estado.id) >= 0
        || (this.model.detalhe.estado.id == 7 && this.model.detalhe.garantiaAtiva == "true"));
  }

  cancelarOperacao() {
    this.cancelamentoService.setOperacaoGarantida(this.model);
    this.router.navigate(['/cancelamento/cadastro']);
  }

  private getModelAsOperacaoRepasse(operacao: any): OperacaoRepasseBndes {
    const retorno: any = operacao;
    return retorno;
  }


  aposSalvar(respServico) {
    this.exibeMensagemSucesso(respServico);
    this.alternarEdicao(false);
    this.modoEdicao = false;
    this.emInclusao = false;
    this.irParaEdicao();
    this.recuperarModelo();
  }


  cancelar() {
    // TODO: VAI SER IMPLEMENTADO DEPOIS...

    this.operacaoService.remove(this.model.id).pipe(takeUntil(this.destroy$)).subscribe(res => {
      this.aposExcluir();
    }, error => {
      this.ocorrencias = this.operacaoService.ocorrencias;
      this.exibeMensagemErro();
    });
  }


  aposExcluir() {
    this.listaOperacoesService.removeLinha(this.model);
    this.exibeMensagemSucesso();
    this.router.navigate(['/operacoes/pesquisa']);
  }

  verificaSePodeSair(): Observable<string> {
    this.vc.abrirModal();
    return this.vc.resultadoConfirm.asObservable();
  }

  private ajustaCasasDecimaisAmortizacoes() {
    const operacaoCreditoLivre = this.getModelAsOperacaoCreditoLivre(this.model);
    if (operacaoCreditoLivre.amortizacoes && operacaoCreditoLivre.amortizacoes.length) {
      for (const amortizacao of operacaoCreditoLivre.amortizacoes) {
        amortizacao.valor = Math.round(amortizacao.valor * 100) / 100;
      }
    }
  }

  retificar() {
    this.ajustaCasasDecimaisAmortizacoes();
    this.modoEdicao = true;
    this.modoRetificacao = true;
    this.modoAditivo = false;
  }

  aditar() {
    this.ajustaCasasDecimaisAmortizacoes();
    this.modoEdicao = true;
    this.modoAditivo = true;
    this.modoRetificacao = false;
  }

  exibeMensagemErro(): void {
    this.ocorrencias.forEach(ocorrencia => {
      console.log(ocorrencia.getToastType());
      // this.messageService.addMessage({
      //  title: 'Erro / aviso',
      //  type: 'CRUD_OPERATION',
      //  level: ocorrencia.getToastType(),
      //  message: ocorrencia.mensagem
      // });
    });
  }

  exibeMensagemSucesso(respServico?: any): void {

    // atribui a mensagem default de sucesso
    let mensagem = 'Operação realizada com sucesso.';

    if (this.opcaoEnvio === 'validar') {
      mensagem = this.criarMensagemEnquandramento();
    }

    if (respServico && respServico.ocorrencias && respServico.ocorrencias.length) {
      mensagem += " Existem avisos.";
    }

    this.messageService.addMessage({
      title: 'Sucesso',
      type: 'CRUD_OPERATION',
      level: messageLevel.SUCCESS,
      message: mensagem
    });
  }

  canDeactivate(): Observable<boolean> | boolean {
    if ((!this.modoEdicao && !this.emInclusao) || this.formGroup.pristine) {
      return true;
    } else {
      // map necessario porque bnConfirm retorna string e nao boolean
      return this.verificaSePodeSair().pipe(map(res => res === 'ok'));
    }
  }

  abrirModal(msg: string, tamanho?: 'sm' | 'md' | 'lg', hasBotoes?: boolean, hasMsgTemplate?: boolean) {
    if (hasBotoes === true) {
      this.modalService.abrir('Confirmação', msg, tamanho, undefined, this.botoesPersonalizados);
    }
  }

  private getModelAsOperacaoCreditoLivre(operacao: any): OperacaoCreditoLivre {
    const retorno: any = operacao;
    return retorno;
  }

  close() {
    this.modalService.close();
  }

  dismiss() {
    this.modalService.dismiss();
  }

  liberar() {
    const operacaoCreditoLivre = this.getModelAsOperacaoCreditoLivre(this.model);
    const navigationExtras: NavigationExtras = {
      state: {
        id: this.idOperacao,
        idOperacaoAgente: operacaoCreditoLivre.idOperacaoAgente,
        liberacoes: operacaoCreditoLivre.detalhe.liberacoes,
        amortizacoes: operacaoCreditoLivre.amortizacoes
      }
    };
    this.router.navigate(['/liberacoes/cadastro', this.idOperacao], navigationExtras);
  }

  amortizar() {
    const operacaoCreditoLivre = this.getModelAsOperacaoCreditoLivre(this.model);
    const navigationExtras: NavigationExtras = {
      state: {
        id: this.idOperacao,
        idOperacaoAgente: operacaoCreditoLivre.idOperacaoAgente,
        fluxoParcelasAposAmortizacao: OperacaoCreditoLivre._getTodasAmortizacoes(operacaoCreditoLivre.amortizacoesAntecipadas, operacaoCreditoLivre.amortizacoes)
      }
    };

    this.router.navigate(['/amortizacoes/cadastro', this.idOperacao], navigationExtras);
  }

  public atribuirOpcaoEnvio(opcaoEnvio: string){
    this.opcaoEnvio = opcaoEnvio;
  }

  public validaCodigoValidacaoUUID(operacaoCreditoLivre: OperacaoCreditoLivre): boolean{
    if (operacaoCreditoLivre.codigoValidacaoProjeto === undefined) {
      this.alertsService.alertaErro("Erro", "É necessário inserir o código de validação da avaliação do projeto.");
      return false;
    }
    if (!operacaoCreditoLivre.codigoValidacaoProjeto.match(/^[0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12}$/)) {
      this.alertsService.alertaErro("Erro", "O campo 'código de validação da avaliação do projeto' foi preenchido incorretamente.");
      return false;
    }
    return true;
  }
  atribuirAlteracaoClienteFinalAditivo(alteracaoClienteFinalAditivo: boolean) {
    this.alteracaoClienteFinalAditivo = alteracaoClienteFinalAditivo;
  }

  exportarJson() {
    if (this.model instanceof OperacaoCreditoLivre) {
      this.operacaoCreditoLivreService.exportarOperacao(this.model.id).pipe(takeUntil(this.destroy$)).subscribe((json) => {
        this.fileUtils.exportarArquivo('Operacao_' + this.model.id + '.json', JSON.stringify(json), FileUtilsService.APPLICATION_JSON);
      });
    }
    else {
      this.operacaoRepasseService.exportarOperacao(this.model.id).pipe(takeUntil(this.destroy$)).subscribe((json) => {
        this.fileUtils.exportarArquivo('Operacao_' + this.model.id + '.json', JSON.stringify(json), FileUtilsService.APPLICATION_JSON);
      });
    }
  }

  verificarOperacaoAtendeRegrasTipoOutrasGarantias(operacaoCreditoLivre: OperacaoCreditoLivre) : boolean {
    this.verificarEnquadramentoMeiENaturezaJuridica(operacaoCreditoLivre);

    const { outrasGarantias, valorOperacao, percentualGarantido } = operacaoCreditoLivre;
    const calc = (valorOperacao * percentualGarantido);
    const valorObrigatorioGarantiaReal: number = 500000000; // 5.000.000,00
    const garantiasSelecionadas = this.garantias.filter(garantia => outrasGarantias.some(outra => outra.tipoGarantia == garantia.id));

    if (garantiasSelecionadas.length == 1 && garantiasSelecionadas[0].id == 0) {
      const nenhuma = '"nenhuma"';
      this.alertsService.alertaErro("Erro", `A seleção de garantia ${nenhuma} é impeditiva para prosseguir com a contratação.`);
      return false;
    }

    const existeGarantiaFidejussoria = garantiasSelecionadas.some(garantia => garantia.fidejussoria === true);
    const existeGarantiaReal = garantiasSelecionadas.some(garantia => garantia.garantiaReal === true);
    const necessitaGarantiaFidejussoria = !(this.indicadorMei || this.naturezaClienteFinal === 2);

    if (necessitaGarantiaFidejussoria && !existeGarantiaFidejussoria) {
      this.alertsService.alertaErro("Erro", `Ao menos uma garantia fidejussoria é necessária para prosseguir com a contratação.`);
      return false;
    }

    if (calc > valorObrigatorioGarantiaReal && !existeGarantiaReal) {
      this.alertsService.alertaErro("Erro", `Valor da operação exige ao menos uma garantia real para prosseguir com a contratação.`);
      return false;
    }

    return true;
  }

  verificarEnquadramentoMeiENaturezaJuridica(operacaoCreditoLivre: OperacaoCreditoLivre) {
    this.indicadorMei = operacaoCreditoLivre.indicadorMicroempreendedorIndividual === 'S' ? true : false;
    this.naturezaClienteFinal = Number(operacaoCreditoLivre.naturezaClienteFinal);
  }

  aditivoCancelado() {
    this.recuperarModelo();
  }

  criarMensagemEnquandramento(): string {
    return `Operação enquadrável ao ${this.modalidadeGarantia} neste instante.`;
  }

  liquidacaoPodeSerInformada() {
    this.podeInformarLiquidacao = this.podeEditar
      && (!this.model?.dataInformeLiquidacao || this.model?.dataInformeLiquidacao == null)
      && this.model?.detalhe?.estado?.id == CODIGO_ESTADO_ATV_S_VINC;
  }

  abrirModalTermosLiquidacao() {
    const modalRef = this._modalService.open(TermosLiquidacaoModalComponent, {
      windowClass: 'modal-dialog-md',
      backdrop: 'static',
      size:'lg'
    });

    modalRef.componentInstance.callback = (respModal) => {
        if(respModal == true){
          this.salvarInformeLiquidacaoOperacao();
        }
    };
  }

  salvarInformeLiquidacaoOperacao() {
      this.loadingService.bloqueiaTela();
      this.operacaoService.informarLiquidacaoOperacao(this.idOperacao).subscribe({
        next: () => {
          this.podeInformarLiquidacao = false;
          this.recuperarModelo();
          this.loadingService.liberaTela();
          this.alertsService.alertaSucesso("Sucesso", "Informe de liquidação gravado com sucesso.");
        },
        error: () => {
          this.loadingService.liberaTela();
          this.alertsService.alertaErro("Erro", "Erro ao gravar informe de liquidação para operação.");
        }
      });
    }

}
